import { jsx } from 'react/jsx-runtime';
import { useId } from '@radix-ui/react-id';
import { useLayoutEffect } from '@radix-ui/react-use-layout-effect';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Label } from '../../../label/Label.mjs';
import { Typography } from '../../../typography/Typography.mjs';
import WhenValidGrandChildren from '../../../utility/WhenValidGrandChildren.mjs';
import useWithLabelProps from '../../hooks/useWithLabelProps.mjs';
import { baseLabel } from '../baseLabel.vanilla.mjs';
import { isSlotAvailable } from '../model.mjs';
import { useTextFieldContext } from './context.mjs';
import { styledLabel } from './label.vanilla.mjs';

const TEXT_FIELD_LABEL_NAME = "TextFieldLabel";
const LabelImpl = forwardRef(
  ({ __scopeTextField, id, ...props }, forwardedRef) => {
    const labelId = useId(id);
    const { size, required, disabled, state, setLabelledBy } = useTextFieldContext(TEXT_FIELD_LABEL_NAME, __scopeTextField);
    useLayoutEffect(() => {
      setLabelledBy(labelId);
    }, [labelId, setLabelledBy]);
    const slotAvailable = isSlotAvailable(size);
    const restLabelProps = useWithLabelProps(props, size);
    const LabelInternal = slotAvailable ? Label : BasicLabel;
    return /* @__PURE__ */ jsx(WhenValidGrandChildren, { children: /* @__PURE__ */ jsx(
      LabelInternal,
      {
        ...restLabelProps,
        id: labelId,
        disabled,
        state,
        size,
        required,
        ref: forwardedRef
      }
    ) });
  }
);
const BasicLabel = forwardRef(
  ({
    children,
    className: classNameFromProps,
    disabled,
    required,
    state,
    size,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames(
          baseLabel({ disabled, required, state }),
          styledLabel({ size }),
          classNameFromProps
        ),
        ref,
        ...props,
        children: /* @__PURE__ */ jsx(Typography, { ellipsis: true, children })
      }
    );
  }
);

export { LabelImpl as default };
//# sourceMappingURL=Label.mjs.map
